import React from 'react';
import { TaskActionButtons } from '../../pages/events/event/Level';
import './TaskCard.scss';

const TaskCard = ({ className = '', top, task, index }) => {

  return (
    <div className={`taskcard ${className}`} style={{ top: top }}>
      <div className='top'>
        <div className='name'>
          <div className='red_dot'></div>
          <h2>{task?.name}</h2>
          <p>{index * 10} Day(s)</p>
        </div>
        <p>{task?.coinshift_level}</p>
      </div>
      <div className='button_container'>
        <TaskActionButtons task={task} />
      </div>
      <div className='info_wrapper'>
        <div className='info'>
          <h4>Details</h4>
          {task?.guide?.map(step => (
            <p>{step}</p>
          ))}
        </div>
        <div className='info'>
          <h4>Rewards</h4>
          {task?.coinshiftRewards?.map(reward => (
            <p>{reward}</p>
          ))}
        </div>
      </div>

      <div className='img_rewards'>
        {task?.coinshiftImgRewards?.map(url => (
          <img src={url} />
        ))}
      </div>
    </div>
  );
};

export default TaskCard;
